import { render, staticRenderFns } from "./shopNavAttr.vue?vue&type=template&id=83843826&scoped=true"
import script from "./shopNavAttr.vue?vue&type=script&lang=js"
export * from "./shopNavAttr.vue?vue&type=script&lang=js"
import style0 from "./shopNavAttr.vue?vue&type=style&index=0&id=83843826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83843826",
  null
  
)

component.options.__file = "shopNavAttr.vue"
export default component.exports